// Nine canonical axes — single source-of-truth for the FE
const TRAIT_AXES = [
    'Curious Questioner ↔ Passionate Expert',
    'Extrovert ↔ Introvert',
    'Adventurous ↔ Cautious',
    'Spontaneous ↔ Planner',
    'Creative ↔ Analytical',
    'Optimist ↔ Realist',
    'Humorous ↔ Earnest',
    'Risk-Taker ↔ Security-Seeker',
    'Storyteller ↔ Question Asker',
  ];
  
  export default TRAIT_AXES;
  